export const TASK_COLUMN_WIDTHS = {
  title: "170px",
  dueDate: "125px",
  responsible: "138px",
  contract: "138px",
  owner: "150px",
  status: "145px",
} as const;

export const fixedWidth = (width: string) => ({ width, minWidth: width, maxWidth: width });
